/** Larguras fechadas da busca; qualquer outra string é uma largura CSS livre. */
export const LIST_TOOLBAR_SEARCH_WIDTHS = ["default", "compact", "wide", "fill"] as const;
